var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookingServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 25.9998H47.6663M43.333 25.9998V43.3332C43.333 44.4824 42.8765 45.5846 42.0638 46.3973C41.2511 47.21 40.1489 47.6665 38.9997 47.6665H12.9997C11.8504 47.6665 10.7482 47.21 9.93554 46.3973C9.12289 45.5846 8.66634 44.4824 8.66634 43.3332V25.9998M8.66634 17.3332L43.333 8.66651M19.1963 14.6898L18.2213 10.7682C18.0816 10.2162 18.0521 9.64207 18.1344 9.07865C18.2167 8.51523 18.4093 7.97356 18.701 7.4846C18.9928 6.99563 19.3781 6.56896 19.8348 6.22898C20.2916 5.889 20.8109 5.64236 21.363 5.50318L25.5663 4.46318C26.1198 4.32383 26.6953 4.29518 27.2599 4.37888C27.8244 4.46258 28.3669 4.65698 28.8561 4.95091C29.3453 5.24484 29.7716 5.63252 30.1106 6.09168C30.4496 6.55084 30.6945 7.07243 30.8313 7.62651L31.8063 11.5265",
    stroke: "#0D9488",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingServices);
export default __webpack_public_path__ + "static/media/cooking-services.6406e5becd05835b526bd2c45d3d22d5.svg";
export { ForwardRef as ReactComponent };